module.exports = __webpack_public_path__ + "assets/ee879694fcd464e12d124ac9f89829eb.png";